import { createAppSelector } from '@/redux/utils'

export const selectMineFunctionPermissions = createAppSelector([
  (state) => state.functionPermission.functionPermissions,
  (state) => state.role.mineRoles,
], (functionPermissions, mineRoles) => {
  const functionIds = new Set(mineRoles.flatMap((role) => role.functionIds))
  return functionPermissions.filter((fp) => functionIds.has(fp.id))
})

export const selectMineFunctionKeys = createAppSelector(
  [selectMineFunctionPermissions],
  (mineFunctionPermissions) => mineFunctionPermissions.map((fp) => fp.key),
)